import * as m from '~/paraglide/messages'
import { Card, CardContent } from '~/shared/ui/card'
import { PageHeader } from '~/widgets/page-header'
import { QrGenerator } from './qr-generator'

export function QrTool() {
  return (
    <div className="space-y-6">
      <PageHeader title={m.qrTool()} description={m.qrToolPageDescription()} />
      <Card>
        <CardContent className="pt-6">
          <QrGenerator />
        </CardContent>
      </Card>
    </div>
  )
}
